import { ReactNode, useState } from 'react';

import { SideItemInfoModel, SideItemsByShape } from '@common/models';
import createTypeSafeContext from '@core/utils/createTypeSafeContext';

export interface ShapeContextValue {
    selectedSideItem?: SideItemInfoModel;
    updateSelectedSideItem: (value: SideItemInfoModel) => void;
    /**
     * An object whose keys are each shape in the design that have modified side items.
     * ```
     * {
     *   'shape1': [
     *    { 'side-a': [{ sideType: 'wall'... }, { sideType: 'appliance'... }, { sideType: 'waterfall'... }] },
     *    { 'side-b': [{ sideType: 'wall'... }, { sideType: 'appliance'... }, { sideType: 'waterfall'... }] },
     *   ],
     *   ...etc
     * }
     * ```
     */
    shapesSideItems: SideItemsByShape;
    updateShapesSideItems: (shapesSideItems: SideItemsByShape) => void;
}

export const [useShapeContext, ShapeContext] = createTypeSafeContext<ShapeContextValue>();

export const ShapeContextProvider = ({ children }: { children?: ReactNode }): JSX.Element => {
    // This is the old way that we should really get rid of
    const [shapesSideItems, setShapesSideItems] = useState<SideItemsByShape>({});
    const [selectedSideItem, setSelectedSideItem] = useState<SideItemInfoModel>();

    const updateShapesSideItems = (value: SideItemsByShape) => {
        setShapesSideItems(value);
    };

    const updateSelectedSideItem = (value: SideItemInfoModel) => {
        setSelectedSideItem(value);
    };

    const shapeContextValue: ShapeContextValue = {
        selectedSideItem,
        updateSelectedSideItem,
        shapesSideItems,
        updateShapesSideItems,
    };

    return <ShapeContext.Provider value={shapeContextValue}>{children}</ShapeContext.Provider>;
};
